import { render } from "./PrintComponent.vue?vue&type=template&id=1645c96e"
import script from "./PrintComponent.vue?vue&type=script&lang=js"
export * from "./PrintComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__